import axios from "axios";

import { setupAxiosInterceptors } from "./interceptors";

const API_URL = process.env.NEXT_PUBLIC_API_URL;

const createAPIClientWithInterceptors = () => {
  const client = axios.create({
    baseURL: API_URL,
    paramsSerializer: { indexes: null },
    withCredentials: true,
  });

  setupAxiosInterceptors(client);

  return client;
};

export const api = {
  client: createAPIClientWithInterceptors(),
};
